<template>
	<div id="PrinterLegalDocumentComponent" class="PrinterLegalDocumentComponent">
		<button ref="btnSetInitComponentDefault" @click="setInitComponentParent" v-show="false">Setear Default</button>
		<button ref="btnSetInitComponentParent" @click="setInitComponentParent" v-show="false">Setear Parent</button>
		<div>
			<div class="form-group">
				<label for="typeLegalDocumentIDSelect">Tipo de Documento</label>
				<select v-model="typeLegalDocumentIDLocal" id="typeLegalDocumentIDSelect" class="form-control form-control-sm">
					<option v-for="(item, index) in listTypeLegalDocuments" :key="index" :value="item.id" v-if="item.weGenerate == 1">{{item.name}}</option>
				</select>
			</div>
			<div class="row">
				<div class="form-group col-md-6">
					<label for="legalDocumentNumberInput">Folio</label>
					<input class="text-end text-right form-control form-control-sm" type="text" v-model="legalDocumentNumberLocal" placeholder="ingrese folio" id="legalDocumentNumberInput"/>
				</div>
				<div class="form-group col-md-6">
					<label for="quantityInput">Copias</label>
					<input class="text-end text-right form-control form-control-sm" type="text" v-model="quantityLocal" placeholder="Nº de copias" id="quantityInput"/>
				</div>
			</div>
			<div class="text-end text-right">
				<button @click="toPrintFacturacionCLLocal" class="btn btn-sm btn-primary" ref="btnPrinter" :disabled="disabledBtnPrinter">
					<span v-if="printingFacturacionCL">
						<div class="spinner-border spinner-border-sm" role="status">
  							<span class="sr-only">Imprimiendo...</span>
						</div>
						Imprimiendo
					</span>
					<span v-else>Imprimir</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import typeLegalDocument from '@/mixins/legalDocuments/typeLegalDocument.js'
	import facturacionCLPrint from '@/mixins/facturacionCLPrint.js'


	export default {
		name: 'PrinterLegalDocumentComponent',
		mixins: [axiosAction, errors, mixin, typeLegalDocument, facturacionCLPrint],
		props: ['typeLegalDocumentID', 'legalDocumentNumber', 'quantity'],
		data () {
		return {
			typeLegalDocumentIDLocal: 0,
			legalDocumentNumberLocal: '',
			quantityLocal: 1
		}
		},
		computed: {
			disabledBtnPrinter() {
				if(this.printingFacturacionCL)
					return true
				if(!this.isInt(this.typeLegalDocumentIDLocal) || this.typeLegalDocumentIDLocal < 1 ||  this.legalDocumentNumberLocal.trim() == '' || !this.isInt(this.legalDocumentNumberLocal.trim()) || this.quantityLocal < 1)
					return true
				return false
			}
		},
		methods: {
			initComponentLocal() {
				this.getAllTypeLegalDocumentsLocal()
				this.setInitComponentDefault()
			},
			getAllTypeLegalDocumentsLocal() {
				this.getAllTypeLegalDocuments()
			},
			getAllTypeLegalDocumentsResultLocal(response) {
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'getAllTypeLegalDocumentsResult': this.getAllTypeLegalDocumentsResult(response); break;				
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			setInitComponentDefault() {
				this.typeLegalDocumentIDLocal = 0
				this.legalDocumentNumberLocal = ''
				this.quantityLocal = 1
				this.printingFacturacionCL = false
			},
			setInitComponentParent() {
				this.typeLegalDocumentIDLocal = this.typeLegalDocumentID
				this.legalDocumentNumberLocal = this.legalDocumentNumber
				this.quantityLocal = this.quantity
			},
			toPrintFacturacionCLLocal() {
				if(this.typeLegalDocumentIDLocal > 0) {
					this.toPrintFacturacionCL(this.typeLegalDocumentIDLocal, this.legalDocumentNumberLocal, '', this.quantityLocal)
				}
			},
		},
		mounted () {
			this.initComponentLocal()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
